import { Component } from '@angular/core';

@Component({
    selector: 'app-infoportal-api',
    templateUrl: './infoportal-api.component.html',
    styleUrls: ['./infoportal-api.component.css'],
    standalone: false
})
export class InfoportalApiComponent { }

